export default __webpack_public_path__ + "static/media/Token.653cab52.svg";